import { AlertDetailsPanel } from "@/features/deployment-dashboard/notifications/alert-details-panel";
import { useNotificationCenter } from "@/features/deployment-dashboard/notification-center/notification-center-context";
import { LiveNotificationsRail } from "@/features/deployment-dashboard/widgets/panels/live-notifications-rail";

/**
 * Layout-level right rail driven by the shared notification center state: the
 * streamed, chronologically-ordered active notification list. Rendered by
 * ConsoleLayout for deployment dashboard pages. Collapsed by default and
 * expanded via the top bar notification bell.
 */
export function NotificationCenterRail() {
  const {
    liveNotifications,
    alertStatuses,
    selectedLiveNotificationId,
    selectLiveNotification,
    closePanel,
  } = useNotificationCenter();
  const activeNotifications = liveNotifications.filter((notification) => {
    if (notification.type !== "alert") return true;
    return alertStatuses.get(notification.notification_id) === "active";
  });
  const selectedNotification = activeNotifications.find(
    (notification) => notification.notification_id === selectedLiveNotificationId
  );

  if (selectedNotification?.type === "alert") {
    return (
      <AlertDetailsPanel
        alertId={selectedNotification.source.id}
        onBack={() => selectLiveNotification(null)}
        floating
      />
    );
  }

  return (
    <LiveNotificationsRail
      notifications={activeNotifications}
      selectedNotificationId={selectedLiveNotificationId}
      onSelectNotification={selectLiveNotification}
      onClosePanel={closePanel}
      floating
    />
  );
}
